module.exports = __webpack_public_path__ + "media/images/icon__predict@3x-b1c13aa9a6cd76bc13b6a8ceceb1d508.png";